import { IResult } from "./IResult"

export class Result {

    static ok<T>(data: T | null): IResult<T> {
        return {
            data: data,
            message: "",
            messageId: 0,
            isFail: false,
            isSuccess: true
        }
    }

    static Fail<T>(messageId: number, message?: string, data: T | null = null): IResult<T> {
        return {
            data: data,
            message: message,
            messageId: messageId,
            isFail: true,
            isSuccess: false
        }
    }

}
